import { render, staticRenderFns } from "./SicSearch.vue?vue&type=template&id=6f149266&"
import script from "./SicSearch.vue?vue&type=script&lang=js&"
export * from "./SicSearch.vue?vue&type=script&lang=js&"
import style0 from "./SicSearch.vue?vue&type=style&index=0&id=6f149266&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports